import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ImageMetadata } from "../types";
import { FrameMetricTooltip } from "./FrameMetricTooltip";

interface FrameQualityOverviewProps {
  imagesForView: ImageMetadata[];
}

const FrameQualityOverview: React.FC<FrameQualityOverviewProps> = ({
  imagesForView,
}) => {
  // Exclude FLAT frames from statistics
  const lightFrames = imagesForView.filter((img) => img.FrameType === "LIGHT");
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 3,
        p: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        minHeight: 340,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          color: "text.primary",
          mb: 0.5,
        }}
      >
        Frame Quality Overview
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        HFR (Half Flux Radius) values across all frames
      </Typography>
      <Box
        sx={{
          width: "100%",
          height: 220,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#181818",
          borderRadius: 2,
        }}
      >
        <ResponsiveContainer width="100%" height={200}>
          <LineChart
            data={lightFrames
              .map((img, i) => ({ frame: i + 1, hfr: img.HFR }))
              .filter((d) => typeof d.hfr === "number" && isFinite(d.hfr))}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <XAxis
              dataKey="frame"
              stroke="#a0a0a0"
              tick={{ fill: "#a0a0a0" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
            />
            <YAxis
              stroke="#a0a0a0"
              tick={{ fill: "#a0a0a0" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
              domain={[0, "auto"]}
            />
            <Tooltip content={<FrameMetricTooltip labelName="HFR" />} />
            <Line
              type="monotone"
              dataKey="hfr"
              stroke="#4fc3f7"
              strokeWidth={2}
              dot={{ r: 2, fill: "#4fc3f7" }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default FrameQualityOverview;
